<template>
  <div>
    <div class="my-4">View Wallet</div>
    <p class="p-3 bg-primary-lighterblue rounded-md">
      We charge a processing fee of N100 each time you fund your wallet
      account.<br /><br />
      Fund transfers to your wallet account appear in your available balance
      within 24hrs. Before then, the net amount transferred will appear under
      'Unsettled Balance'.<br /><br />
      Regular transaction charges capped at N50 per transaction apply when you
      pay for healthcare services.
    </p>
    <div class="flex justify-end my-12">
      <button
        v-if="isActive"
        @click="isActive && (showPaymentModal = true)"
        class="bg-primary-yellow py-2 px-3 rounded-sm"
        :class="[isActive ? 'opacity-100' : 'opacity-50']"
      >
        Fund Wallet
      </button>
      <button
      v-if="hasNoWallet"
      @click="showActivateWallet = true"
      class="px-3 py-2 bg-primary-yellow rounded-md shadow-md"
    >
      Activate Wallet
    </button>
    </div>

    <div>
      <div
        class="flex justify-between items-center flex-wrap shadow-md rounded-md px-2"
      >
        <div
          class="flex justify-between items-center w-full sm-w-6/12 md:w-4/12 lg:w-3/12 card_props"
        >
          <div class="mr-3">
            <img src="@/assets/images/wallet/user_icon.svg" class="w-16" />
          </div>
          <div class="w-full">
            <span class="uppercase text-sm font-bold opacity-50"
              >Account NAME</span
            >
            <p class="text-base">
              {{
                `${userWallet.user ? userWallet.user.firstname : ""} ${
                  userWallet.user ? userWallet.user.lastname : ""
                }` || ""
              }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-center w-full sm-w-6/12 md:w-4/12 lg:w-3/12 card_props"
        >
          <div class="mr-3">
            <img src="@/assets/images/wallet/wallet_icon.svg" class="w-16" />
          </div>
          <div class="w-full">
            <span class="uppercase text-sm font-bold opacity-50"
              >WALLET ID #</span
            >
            <p class="text-base">122238478</p>
          </div>
        </div>
        <div
          class="flex justify-between items-center w-full sm-w-6/12 md:w-4/12 lg:w-3/12 card_props"
        >
          <div class="mr-3">
            <img src="@/assets/images/wallet/unsettled_icon.svg" class="w-16" />
          </div>
          <div class="w-full">
            <span class="uppercase text-sm font-bold opacity-50"
              >UNSETTELED BAL. (NGN)</span
            >
            <p class="text-base">N0.00</p>
          </div>
        </div>
        <div
          class="flex justify-between items-center w-full sm-w-6/12 md:w-4/12 lg:w-3/12 card_props"
        >
          <div class="mr-3">
            <img
              src="@/assets/images/wallet/available_bal_icon.svg"
              class="w-16"
            />
          </div>
          <div class="w-full">
            <span class="uppercase text-sm font-bold opacity-50"
              >AVAILABLE BAL. (NGN)</span
            >
            <p class="text-base">
              {{
                userWallet.balance
                  ? amountFomatter(userWallet.balance / 100)
                  : "0"
              }}.00
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="text-right pt-8 mt-16 flex items-center justify-between flex-wrap"
    >
      <div class="w-full md:w-6/12 flex justify-start items-center">
        <i
          class="ball"
          :class="[isActive ? 'bg-primary-green' : 'bg-red-600']"
        ></i>
        {{ isActive ? "Active" : "Deactivated" }}
      </div>

      <div class="w-full md:w-6/12">
        <button
          class="py-2 px-4 inline-flex items-center"
          @click="$router.push('/payments/account-statement/account')"
        >
          <img src="@/assets/images/wallet/eye_icon.svg" class="mr-2" />
          View Statement
        </button>
        <button
          class="py-2 px-4 inline-flex items-center"
          @click="
            isActive ? (showDeactivatewallet = true) : activateWalleFunct()
          "
        >
          <img
            v-if="isActive"
            src="@/assets/images/wallet/deactivate_icon.svg"
            class="mr-2"
          />
          <span v-else class="ball-green"></span>
          {{ isActive ? "Deactivate Account" : "Activate Account" }}
        </button>
      </div>
    </div>

    <PaymentModal
      @close-modal="showPaymentModal = false"
      :show-modal="showPaymentModal"
      @refresh="refresh"
    />
    <DeactivateWallet
      @closeModal="showDeactivatewallet = false"
      :show-modal="showDeactivatewallet"
      @deactivateWallet="deactivateWallet"
      @reset="refresh"
    />
    <ActivateWallet
    @closeModal="showActivateWallet = false"
    :show-modal="showActivateWallet"
    />
  </div>
</template>

<script>
import PaymentModal from "@/components/Ondemand/Payments/modals/PaymentModal.vue";
import DeactivateWallet from "./Modal/DeactivateWallet.vue";
import ActivateWallet from "./Modal/ActivateWalletNew.vue"


export default {
  data() {
    return {
      userWallet: {},
      showPaymentModal: false,
      showDeactivatewallet: false,
      isActive: false,
      showAddWallet: false,
      showActivateWallet: false,
      hasNoWallet: false,
      paystackkey: "pk_test_d81d41eedf44bac3067b59281f5aec31efc13049",
    };
  },
  components: { PaymentModal, DeactivateWallet, ActivateWallet },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("loggedInUser"));
    },
  },
  mounted() {
    this.getUserWalletDetails();
  },
  methods: {
    refresh() {
      this.getUserWalletDetails();
    },
    async deactivateWallet() {
      try {
        await this.$_deactivateWallet();
        this.getUserWalletDetails();
      } catch (error) {
        //
      }
    },
    async activateWalleFunct() {
      try {
        await this.$_activateWallet();
        this.getUserWalletDetails();
      } catch (error) {
        //
      }
    },
    async getUserWalletDetails() {
      this.userWallet = {};
      try {
        const response = await this.$_getUserWallet(
          localStorage.getItem("userId")
        );
        this.userWallet = response.data.userWallet;
        this.isActive = true;
        this.hasNoWallet = false
      } catch (error) {
        const status = { error }.error.request.status;
        if (status === 404) {
          this.isActive = false;
          this.hasNoWallet = true
          this.showActivateWallet = true
        } else if (status === 409) {
          this.isActive = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ball {
  width: 10px;
  height: 10px;
  border-radius: 50px;
  display: inline-block;
  margin-right: 6px;
}
.card_props {
  @apply py-3;
}
.ball-green {
  display: inline-block;
  width: 15px;
  height: 15px;
  @apply rounded-full bg-primary-green mr-1;
}
</style>
